import { Http, Headers, Response } from "@angular/http";
import { Storage } from '@ionic/storage';
import { App } from 'ionic-angular';
import 'rxjs/add/operator/toPromise';

export class HttpService {

    constructor (
        public http:Http ,
        protected storage:Storage ,
        protected app:App
    ) {}

    headers() : Promise<Headers> {
        return new Promise<Headers>((resolve, reject) => {
            this.storage.get('token')
                .then(token => {
                    if (token) {
                        let headers = new Headers();
                        headers.append('X-Token', token);
                        resolve(headers);
                    } else {
                        reject('no token set');
                    }
                }).catch(e => {
                    reject(e);
                });
        });
    }

    moveToLogin() {
        this.app.getRootNav().setRoot('login');
        // window.location.reload();
    }

    file(url:string, file:File) : Promise<Response> {
        let data = new FormData();
        data.append('file', file, file.name);

        return new Promise<Response>((resolve, reject) => {
            this.headers()
                .then(headers => {
                    headers.append('Accept', 'application/json');

                    this.http.post(url, data, {
                        headers : headers
                    }).subscribe(response => {
                        resolve(response);
                    }, error => {
                        reject();
                    });
                })
        });
    }

    put(url:string, data:any) : Promise<Response> {
        return new Promise<Response>((resolve, reject) => {
            this.headers()
                .then(headers => {
                    this.http.put(url, data, {
                        headers : headers
                    }).subscribe(response => {
                        resolve(response);
                    }, error => {
                        this.moveToLogin();
                    });
                }).catch((error) => {
                    this.moveToLogin();
                });

        });
    }

    post(url:string, data:any) : Promise<Response> {
        return new Promise<Response>((resolve, reject) => {
            this.headers()
                .then(headers => {
                    this.http.post(url, data, {
                        headers : headers
                    }).subscribe(response => {
                        resolve(response);
                    }, error => {
                        this.moveToLogin();
                    });
                }).catch((error) => {
                    this.moveToLogin();
                });
        });
    }

    get(url:string, params:any = undefined) : Promise<Response> {
        return new Promise<Response>((resolve, reject) => {
            this.headers()
                .then(headers => {
                    this.http.get(url, {
                        headers : headers ,
                        params : params
                    }).subscribe(response => {
                        resolve(response);
                    }, error => {
                        this.moveToLogin();
                    });
                }).catch((error) => {
                    this.moveToLogin();
                });

        });
    }

    delete(url:string) : Promise<Response> {
        return new Promise<Response>((resolve, reject) => {
            this.headers()
                .then(headers => {
                    this.http.delete(url, {
                        headers : headers
                    }).subscribe(response => {
                        resolve(response);
                    }, error => {
                        this.moveToLogin();
                    });
                }).catch((error) => {
                    this.moveToLogin();
                });
        });
    }

}



// WEBPACK FOOTER //
// ./src/services/http/http-service.ts